export default function CTASection() {
  return (
    <section className="relative py-20 md:py-28 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20flat%20lay%20of%20diverse%20lifestyle%20fashion%20accessories%20including%20watches%20sunglasses%20and%20small%20leather%20goods%20arranged%20in%20organized%20grid%20on%20warm%20cream%20surface%20soft%20diffused%20top%20lighting%20clean%20commercial%20aesthetic%20elegant%20minimal%20no%20text%20no%20logos&width=1800&height=800&seq=cta-bg-v3&orientation=landscape"
          alt="CSSBuySpreadsheet - Planilha de produtos"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-black/35 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-start lg:items-end justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-background-50 mb-4 leading-tight">
              Comece a comprar com a melhor planilha
            </h2>
          </div>

          <div className="max-w-md">
            <p className="text-sm md:text-base text-background-200/90 leading-relaxed mb-6">
              Acesse agora mesmo a planilha completa no kaspreadsheet.com e
              descubra os melhores links CSSBuy atualizados diariamente.
              Economize tempo e dinheiro com vendedores verificados.
            </p>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-8 py-3.5 bg-background-50 text-foreground-900 rounded-full text-sm font-semibold hover:bg-background-100 transition-all whitespace-nowrap cursor-pointer group"
            >
              <span>Acessar kaspreadsheet.com</span>
              <span className="w-7 h-7 rounded-full bg-foreground-900 flex items-center justify-center group-hover:bg-primary-500 transition-colors">
                <i className="ri-arrow-right-line text-background-50 text-xs"></i>
              </span>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}